import React from 'react';

const ConsultantProjectConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/upload/consultantproject',
            component: React.lazy(() => import('./consultantProject.js'))
        }
    ]
};

export default ConsultantProjectConfig;